<section>
    <highcharts-chart [Highcharts]="highcharts" [options]='widget' [className]='className' style="width: 100%; height: 100%; display: block;">
    </highcharts-chart>
</section>
